import type { SVGProps } from "react";
export interface HotdogIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HotdogIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HotdogIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.206 8.206a1.125 1.125 0 0 1 1.505-.077l.085.077.503.501.27.3a3.955 3.955 0 0 1-.27 5.293l-7 6.999a3.955 3.955 0 0 1-5.292.27l-.3-.27-.501-.502-.078-.085a1.125 1.125 0 0 1 1.582-1.584l.087.078.5.502.131.116c.67.546 1.657.508 2.281-.116l6.999-6.999.116-.129c.51-.625.51-1.527 0-2.152l-.116-.13-.502-.501-.078-.086a1.125 1.125 0 0 1 .078-1.505m-1.462-3.08a1.125 1.125 0 0 1 .011 2.25c-.136 0-.343.074-.533.263a.9.9 0 0 0-.249.42l-.014.113c-.005.84-.4 1.59-.923 2.113-.458.457-1.089.817-1.802.904l-.312.019c-.137 0-.344.075-.533.265a.9.9 0 0 0-.25.419l-.014.114c-.005.84-.4 1.59-.923 2.112-.523.523-1.272.918-2.112.923-.137 0-.345.075-.535.265s-.263.397-.264.533c-.004.84-.4 1.59-.922 2.113-.458.457-1.089.818-1.802.904l-.31.019-.116-.005a1.125 1.125 0 0 1 .104-2.245l.114-.015a.9.9 0 0 0 .419-.25c.19-.189.263-.396.263-.532.005-.84.4-1.59.923-2.113s1.272-.92 2.113-.924c.136 0 .345-.074.534-.264s.263-.396.264-.533l.019-.31c.086-.714.446-1.344.904-1.802.523-.523 1.272-.92 2.112-.924l.114-.015a.9.9 0 0 0 .42-.25c.189-.189.264-.395.264-.532l.02-.31c.085-.714.446-1.345.903-1.803.523-.522 1.272-.918 2.113-.922m-7.74-2.693a3.955 3.955 0 0 1 5.292.273l.498.498.078.085a1.125 1.125 0 0 1-1.582 1.583l-.087-.077-.498-.499a1.704 1.704 0 0 0-2.28-.117l-.131.117-6.998 6.998a1.705 1.705 0 0 0 0 2.411l.498.498.078.087a1.125 1.125 0 0 1-1.583 1.582l-.085-.078-.498-.498a3.955 3.955 0 0 1 0-5.593l6.997-6.997z"
      />
      <path
        fill={color}
        d="M15.343 2.072a4.66 4.66 0 0 1 6.419.166l.165.174a4.66 4.66 0 0 1 0 6.245l-.165.174L8.836 21.757a4.66 4.66 0 0 1-6.42.165l-.173-.165a4.663 4.663 0 0 1 0-6.593L15.168 2.238zM20.17 3.83a2.41 2.41 0 0 0-3.227-.166l-.183.166L3.833 16.756a2.41 2.41 0 0 0 0 3.41l.183.166a2.413 2.413 0 0 0 3.229-.166L20.171 7.24a2.413 2.413 0 0 0 .165-3.228z"
      />
    </svg>
  );
}
